export const css = {
	oneaction: '_3bfnv_NG',
	' _key': 'apic-theme/apic/quiz-widgets/prometric-review'
};

export default css;
